export default "__VITE_ASSET__ad85a936__"